import { render, staticRenderFns } from "./WeekItem.vue?vue&type=template&id=0b66d02c"
import script from "./WeekItem.ts?vue&type=script&lang=ts&external"
export * from "./WeekItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports